// Import browser history to use throughout the application
import { createBrowserHistory } from "history";
export default createBrowserHistory();